export default __webpack_public_path__ + "static/DomaineTextWeb-Regular-87a8bcf93c1c8f3e4a789b458be8db45.woff";